import Note from "./notes/Note"

const notes = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B', 'c']
const frets = ['C', 'D', 'E', 'F', 'G', 'A', 'B', 'c']

const Lines = ({y, width, height}) => {
    const heights = []
    for (let i = 0; i < 5; i++) {
        heights.push((height) * i / 5 + 1 + y)
    }
    return (
        <g stroke="#000000" strokeWidth={2}>
            {heights.map(h => <line x1={0} x2={width} y1={h} y2={h}/>)}
        </g>
    )
}

const durationAndValueToNoteName = (duration, value) => {
    if (duration == 1) {
        if (value == -1) {
            return 'QuarterRest'
        } else {
            return 'QuarterNote'
        }
    }
    else if (duration == 2) {
        if (value == -1) {
            return 'HalfRest'
        } else {
            return 'HalfNote'
        }
    }
    else if (duration == 3) {
        if (value == -1) {
            return 'DottedHalfRest'
        } else {
            return 'DottedHalfNote'
        }
    }
    else {
        if (value == -1) {
            return 'WholeRest'
        } else {
            return 'WholeNote'
        }
    }
}

const valueToNote = (value) => {
    const n = notes[value]
    const spl = n.split('')

    const yValue = 71 + 10 * (8 - frets.indexOf(spl[0]))
    if (spl.length == 2) {
        return {'y': yValue, 'sharp': true}
    }
    return {'y': yValue, 'sharp': false}
}

const Bars = ({notes, numBars}) => {
    const bars = []
    let currentBar = []
    let barCount = 1
    const barWidth = 1000 / numBars
    let sharpNotes = {}
    for (let i = 0; i < notes.length; i++) {
        let value = notes[i].value
        let duration = notes[i].duration
        let type = durationAndValueToNoteName(duration, value)
        let xSpacing = (barWidth / 5 * barCount) + (bars.length * barWidth)
        
        let ySpacing = 0
        let sharp = false
        let natural = false
        if (value > -1) {
            let noteInfo = valueToNote(value)
            ySpacing = noteInfo['y']

            let sh = noteInfo['sharp']

            if (!sh && sharpNotes[ySpacing]) {
                natural = true
                sharpNotes[ySpacing] = false
            } else if (sh && !sharpNotes[ySpacing]) {
                sharp = true
                sharpNotes[ySpacing] = true
            }
        }
        
        currentBar.push({type: type, x: xSpacing, y: ySpacing, sharp: sharp, natural: natural})
        barCount += duration
        if (barCount > 4) {
            bars.push(
                <g>
                    {currentBar.map(n => <Note type={n.type} x={n.x} y={n.y} sharp={n.sharp} natural={n.natural}/>)}
                    <line x1={barWidth * (bars.length + 1) - 1} x2={barWidth * (bars.length + 1) - 1} y1={50} y2={130} stroke="#000000" strokeWidth={2}/>
                </g>
            )
            currentBar = []
            sharpNotes = {}
            barCount = 1
        }
    }
    return (
        <g>
            {bars.map(bar => bar)}
        </g>
    )
}

const SheetMusic = ({data}) => {
    return (
        <div>
            <svg width={1000} height={200}>
                <Bars notes={data.notes} numBars={data.bars}/>
                <Lines y={50} width={1000} height={100} />
            </svg>
        </div>
    )
}

export default SheetMusic